export const obterFiltro = ({ filtros }) => (contexto, campo, valorPadrao = null) => {
  const filtrosAtuais = filtros[contexto]
    ? JSON.parse(filtros[contexto])
    : {}

  return filtrosAtuais.hasOwnProperty(campo) ? filtrosAtuais[campo] : valorPadrao
}
export const obterFiltros = ({ filtros }) => (contexto) => filtros[contexto] ? JSON.parse(filtros[contexto]) : {}

export const obterOrdenacao = ({ ordenacao }) => (contexto, campo, valorPadrao = null) => {
  const ordenacaoAtual = ordenacao[contexto]
    ? JSON.parse(ordenacao[contexto])
    : {}

  return ordenacaoAtual.hasOwnProperty(campo) ? ordenacaoAtual[campo] : valorPadrao
}
